export default function template() {
    return `
	<p class="p1"><span class="s1">Hillary Clinton led the field for the Democratic nomination 
	from the beginning of the campaign in early 2015 on her road to becoming the party’s nominee. 
	Yet over the course of the campaign, many Democratic voters switched their preferences at least 
	once. Below you can explore how she and other candidates gained (and lost) supporters among the
	 same nationally representative group of Democratic and Democratic-leaning registered voters in 
	 Pew Research Center’s&nbsp;
	 <a href="https://www.pewresearch.org/methodology/u-s-survey-research/american-trends-panel/">
		 <span class="s2">American Trends Panel</span>
	</a>. 
	Walk through Hillary Clinton’s road to the nomination, explore shifts in Bernie Sanders’ support or 
	follow early backers of Elizabeth Warren on your own. And for more on the patterns of support 
	throughout the primary, and into the general election, see “
	</span>
	<a href="https://www.people-press.org/2016/07/25/in-clintons-march-to-nomination-many-democrats-changed-their-minds">
	<span class="s3">In Clinton's March to Nomination, Many Democrats Changed Their Minds</span></a>
	<span class="s1">.”</span></p>
    <div id="interactive">
		<div id="chart_stuff">
			<div id="buttons">
				<button id="clinton-path" class="ui medium button">Follow Clinton's path to the nomination</button>
				<button id="all-democrats" class="ui medium button">Explore all the Democratic candidates</button>
				<a href="https://www.people-press.org/interactives/gop-candidate-switching/" class="more">Republicans and Trump <span class="arrow" aria-hidden="true">→</span></a>
			</div>

			<div id="all-democrats-dropdown">
				<p>Show where
					<select id="candidate-drop"><!-- Value 2 dropout line: March-August = 19%, August-December = 40%, December-April = 62%, April-June = 83% -->
						<option>Select one</option>
						<option value="biden" Mar="1" Aug="5" Dec="1" Apr="<1" Gen="">Biden</option>
						<option value="clinton" selected Mar="41" Aug="38" Dec="48" Apr="46" Gen="90">Clinton</option>
						<option value="omalley" value2="62" Mar="<1" Aug="<1" Dec="1" Apr="<1" Gen="">O'Malley</option>
						<option value="sanders" Mar="2" Aug="22" Dec="29" Apr="37" Gen="">Sanders</option>
						<option value="warren" Mar="10" Aug="1" Dec="<1" Apr="<1" Gen="">Warren</option>
						<option value="other" Mar="7" Aug="6" Dec="4" Apr="2" Gen="">Other</option>
						<option value="undecided" Mar="39" Aug="28" Dec="18" Apr="14" Gen="">Undecided</option>
					</select>
					 supporters
					<select id="direction-drop">
						<option value="cameFrom" selected>came from</option>
						<option value="wentTo">went</option>
					</select>
				</p>
			</div>
			<div class="time-label">March 2015</div>
			<div class="time-label">Aug. 2015</div>
			<div class="time-label">Dec. 2015</div>
			<div class="time-label">April 2016</div>
			<div class="time-label" id="last-time-label">General Election/<br>June 2016</div>
			<div id="chart">
				<div class="verticalLine"></div>
				<div class="dropoutText"><span></span><br>suspends<br>campaign</div>
				<div id="Aug15-div" class="story-boxes">
					<div class="story-textbox">
						<div class="clinton-img-wrapper"><img src="//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/Clinton.png";></div>
						<div class="story-title">Early stages</div>
						<p>In March 2015, before any of the Democratic candidates had formally announced their candidacies, 41% of Democratic voters named Hillary Clinton as their first choice for the nomination. About as many said they were undecided (39%), while the next most popular choice was Elizabeth Warren (10%).</p>
						<p id="first-story"><a href="javascript:;" id="Aug15-link" class="clinton-link">Next &#62;</a></p>
					</div>
				</div>
				<div id="Dec15-div" class="story-boxes">
					<div class="story-textbox" >
						<div class="story-title">Sanders enters and Warren opts out</div>
						<p>By August 2015, after Bernie Sanders’ entry into the race and Warren’s decision not to run, Clinton’s support had dropped slightly to 38% of Democratic voters. Many of Warren’s March supporters moved to Sanders (56%, compared with 12% who moved to Clinton). Still, Clinton held on to the support of most of her March supporters over this period, and picked up some support from previously undecided voters.</p>
						<p><a href="javascript:;" id="Dec15-link-prev" class="clinton-link">&#60; Previous</a><a href="javascript:;" id="Dec15-link" class="clinton-link">Next &#62;</a></p>
					</div>
				</div>
				<div id="Apr16-div" class="story-boxes">
					<div class="story-textbox" >
						<div class="story-title">Some voters switch support between Clinton and Sanders</div>
						<p>Clinton's support grew in December to nearly half (48%) of Democratic voters, while Sanders stood at 29%. Some Democrats changed their minds over this period: About one-in-ten of Clinton’s December supporters (9%) had backed Sanders in August, while a similar share (15%) of his December supporters had previously backed her. </p>
						<p><a href="javascript:;" id="Apr16-link-prev" class="clinton-link">&#60; Previous</a><a href="javascript:;" id="Apr16-link" class="clinton-link">Next &#62;</a></p>
					</div>
				</div>
				<div id="June16-div" class="story-boxes">
					<div class="story-textbox" >
						<div class="story-title">Clinton continues to hold a lead, but it narrows as Sanders sees greater gain</div>
						<p>By April, deep into the primaries, Clinton’s overall lead over Sanders had narrowed substantially, as he gained more supporters during this period: 74% of her April supporters had supported her in December; by comparison, 59% of his April supporters had been December supporters.</p>
						<p><a href="javascript:;" id="June16-link-prev" class="clinton-link">&#60; Previous</a><a href="javascript:;" id="June16-link" class="clinton-link">Next &#62;</a></p>
					</div>
				</div>
				<div id="unity" class="story-boxes">
					<div class="story-textbox" >
						<div class="story-title ">Unity in the general</div>
						<p>After Clinton clinched the nomination and became the presumptive nominee, most Sanders supporters came to back her in the general. As of June, Clinton is the choice of 90% of Democratic voters (including 90% of Sanders’ April supporters) in a general election matchup against Donald Trump.</p>
						<div id = "unity-button-container">
							<button id="unity-button" class="ui large button clinton-link">Explore all the Democratic candidates</button>
						</div>
					</div>
				</div>
			</div>

			<div class="time-blurb" id="Mar-blurb">
				<p class="time-blurb-para"><span>41%</span> of Democratic voters named Clinton their first choice in March 2015.</p>
			</div>
			<div class="time-blurb" id="Aug-blurb">
				<p class="time-blurb-para"><span>38%</span> of Democratic voters named Clinton their first choice in August 2015.</p>
			</div>
			<div class="time-blurb" id="Dec-blurb">
				<p class="time-blurb-para"><span>48%</span> of Democratic voters named Clinton their first choice in December 2015.</p>
			</div>
			<div class="time-blurb" id="April-blurb">
				<p class="time-blurb-para"><span>46%</span> of Democratic voters named Clinton their first choice in April 2016.</p>
			</div>
			<div class="time-blurb" id="June-blurb">
				<p class="time-blurb-para"><span>90%</span> of Democratic voters named Clinton their first choice in the general election.</p>
			</div>
		</div>
		<div class="source_div">
			<p class="source">Source: Pew Research Center American Trends Panel surveys, conducted March 2015 through June 2016. Based on Democratic and Democratic-leaning registered voters (March & August 2015, N=1,518; December 2015, April and June 2016 N=2,353). <a href="https://www.people-press.org/2016/07/25/in-clintons-march-to-nomination-many-democrats-changed-their-minds/2/#methodology">See methodology for more detail</a>.</p>
			<p class="source">Photo credits: Brook Christopher/WireImage/Getty Images (Biden); Brendan Smialowski/AFP/Getty Images (Clinton); Steve Sands/Getty Images (O'Malley);  Alex Wong/Getty Images (Sanders); Saul Loeb/AFP/Getty Images (Warren)</p>
		</div>

	</div>

	<div id="static_mobile">
		<h3>Early stages</h3>
		<p>In March 2015, before any of the Democratic candidates had formally announced their candidacies, 41% of Democratic voters named Hillary Clinton as their first choice for the nomination. About as many said they were undecided (39%), while the next most popular choice was Elizabeth Warren (10%).</p>
		<img src="//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/PP_16.07.24_clintonPathMobile_1.png">

		<h3>Sanders enters and Warren opts out</h3>
		<p>By August 2015, after Bernie Sanders’ entry into the race and Warren’s decision not to run, Clinton’s support had dropped slightly to 38% of Democratic voters. Many of Warren’s March supporters moved to Sanders (56%, compared with 12% who moved to Clinton). Still, Clinton held on to the support of most of her March supporters over this period, and picked up some support from previously undecided voters.</p>
		<img src="//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/PP_16.07.24_clintonPathMobile_2.png">

		<h3>Some voters switch support between Clinton and Sanders</h3>
		<p>Clinton's support grew in December to nearly half (48%) of Democratic voters, while Sanders stood at 29%. Some Democrats changed their minds over this period: About one-in-ten of Clinton’s December supporters (9%) had backed Sanders in August, while a similar share (15%) of his December supporters had previously backed her. </p>
		<img src="//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/PP_16.07.24_clintonPathMobile_3.png">

		<h3>Clinton continues to hold a lead, but it narrows as Sanders sees greater gain</h3>
		<p>By April, deep into the primaries, Clinton’s overall lead over Sanders had narrowed substantially, as he gained more supporters during this period: 74% of her April supporters had supported her in December; by comparison, 59% of his April supporters had been December supporters. </p>
		<img src="//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/PP_16.07.24_clintonPathMobile_4.png">

		<h3>Unity in the general</h3>
		<p>After Clinton clinched the nomination and became the presumptive nominee, most Sanders supporters came to back her in the general. As of June, Clinton is the choice of 90% of Democratic voters (including 90% of Sanders’ April supporters) in a general election matchup against Donald Trump.</p>
		<img src="//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/PP_16.07.24_clintonPathMobile_5.png">

		<p class="source">Source: Pew Research Center American Trends Panel surveys, conducted March 2015 through June 2016. Based on Democrat and Democrat-leaning registered voters (March & August 2015, N=1,345; December 2015, April and June 2016 N=2,079). <a href="https://www.people-press.org/2016/07/25/in-clintons-march-to-nomination-many-democrats-changed-their-minds/2/#methodology" target="_blank">See methodology for more detail</a>.</p>
	</div>
	`;
}
